import { request } from "@frontend/lib/http";

import type { ClientOption } from "../types";

type RequestOptions = {
  signal?: AbortSignal;
};

export type ClientFieldApi = {
  fetchClients(options?: RequestOptions): Promise<ClientOption[]>;
};

export const clientFieldApi: ClientFieldApi = {
  fetchClients(options) {
    return request({ route: "api_clients_references", ...options });
  },
};
